module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('section', {
    attrs: {
      "aria-labelledby": "pro",
      "epub:type": "prologue",
      "role": "doc-prologue"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "Chap-Number-cn"
  }, [_c('span', {
    attrs: {
      "aria-label": "1",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_pro",
      "id": "pro",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("PROLOGUE")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "Chap-Opening-Text-No-Indent-cotx1"
  }, [_vm._v("The monster in the mountain was awake.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Even outside, under stars drowning in a dark North Dakota sky, the little girl felt it stir. She waited to see if it would come for her; steal through the dark and drag her back.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Standing in the dust from her escape, she felt it move within the stone and become still.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("A mournful hooting interrupted the silence. The girl looked away from the towering stone to stare across the vast emptiness illuminated by a shy moon peeking out just enough to reveal land formations in the distance, thick and blocky. She wanted to run to them, and whatever lay beyond, and never stop.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Instead, she slowly turned back to the mountain, knowing what she left behind. It hurt so badly, she felt she might die on the spot.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("But she was only nine years old, and she wanted to live.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She’d almost forgotten about the outside world, having been asleep inside the mountain for so long. But then a man had appeared in her dark dreams and reminded her that there was, in fact, a real world to which she belonged. He looked as frightened as she.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She wanted to reach out to him and never let go, as she once had the small velvet bag containing her meager possessions. There hadn’t been much in that bag, just a plastic ring, a marble, and a top that blurred the color of the rainbow when it spun. She’d loved that bag, even slept with it, "), _c('span', {
    attrs: {
      "aria-label": "2",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("holding it close to her chest, until the night came that never ended, and the monster emerged from the black.")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("The girl had no idea how she’d escaped, where to go, or what to do. She thought of the man, with his kind face and thick hair that swirled in waves. He’d seen her, too; she knew it. He’d seen the awful things that had happened in her dreams. He’d shown her she wasn’t alone. All she knew was that after he’d appeared, she found a way out.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("She had to find him, even if it meant leaving behind what mattered to her most in the world.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("“I promise,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Feeling the aching breach in her heart, she turned from the mountain and began to walk.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33bfd489","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/prologue.vue
// module id = 72
// module chunks = 0